import { QSetStatus, useDisableQSetsMutation } from '@exam-management/graphql';
import { ConfirmationModal, Text } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

import { useQSetListSearchParams } from '../../hooks';

interface QSetDisablementModalProps {
  open: boolean;
  onClose: () => void;
  qSetIds: string[];
}

export default function QSetDisablementModal(props: Readonly<QSetDisablementModalProps>) {
  const { open: isOpen, onClose, qSetIds } = props;
  const { showSnackbar } = useSnackbar();

  const [, { changeStatus }] = useQSetListSearchParams();
  const [disableQSets, { loading: isDisablingQSets }] = useDisableQSetsMutation();

  const handleConfirm = async () => {
    await disableQSets({
      variables: {
        input: {
          qSetIds,
        },
      },
      onCompleted: () => {
        showSnackbar({
          variant: 'success',
          message: 'QSet has been disabled',
        });
        changeStatus(QSetStatus.Disabled);
      },
      onError: () => {
        showSnackbar({
          variant: 'error',
          message: 'Unable to Disable QSet',
        });
      },
    });
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <ConfirmationModal
      open={isOpen}
      title='Disable QSet?'
      content={
        <Text>
          เมื่อทำการ Disable แล้ว จะไม่สามารถนำชุดข้อสอบไปใช้จัดสอบได้อีก
          กรุณาตรวจสอบความถูกต้องให้เรียบร้อยก่อนดำเนินการต่อ
        </Text>
      }
      onAccept={handleConfirm}
      onClose={handleCancel}
      onDiscard={handleCancel}
      loading={isDisablingQSets}
      acceptText='Disable'
      discardText='Cancel'
    />
  );
}
